
import Vue from 'vue'

const locales = {keys(){return []}}
global['____07C0A0D____'] = true;
delete global['____07C0A0D____'];
global.__uniConfig = {"tabBar":{"borderStyle":"black","selectedColor":"#37B24D","color":"#909399","list":[{"pagePath":"app/index/index","iconPath":"static/public/icon/home.png","selectedIconPath":"static/public/icon/home_.png","text":"主页","redDot":false,"badge":""},{"pagePath":"app/orders/index","iconPath":"static/public/icon/order.png","selectedIconPath":"static/public/icon/order_.png","text":"订单","redDot":false,"badge":""},{"pagePath":"app/mine/index","iconPath":"static/public/icon/mine.png","selectedIconPath":"static/public/icon/mine_.png","text":"我的","redDot":false,"badge":""}],"backgroundColor":""},"globalStyle":{"navigationStyle":"custom","backgroundColor":"#FFFFFF"},"uniIdRouter":{}};
global.__uniConfig.compilerVersion = '4.56';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__07C0A0D';
global.__uniConfig.appName = 'x';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"./"};
global.__uniConfig.publicPath = "./";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('app-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/index/index"+'.vue')), 'app-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-search-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/search/index"+'.vue')), 'app-search-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-mine-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/mine/index"+'.nvue')), 'app-mine-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-user_info-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/user_info/index"+'.nvue')), 'app-user_info-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-about-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/about/index"+'.nvue')), 'app-about-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-product_detail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/product_detail/index"+'.vue')), 'app-product_detail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-help-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/help/index"+'.vue')), 'app-help-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-order_submit-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/order_submit/index"+'.vue')), 'app-order_submit-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-query_record-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/query_record/detail"+'.vue')), 'app-query_record-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-notification-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/notification/detail"+'.vue')), 'app-notification-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-order_result-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/order_result/index"+'.vue')), 'app-order_result-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-orders-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/orders/index"+'.vue')), 'app-orders-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-orders-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/orders/detail"+'.vue')), 'app-orders-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('app-wechat-only-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/tim/code/low/client/mini.jamnote.uni/app/wechat-only/index"+'.vue')), 'app-wechat-only-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/app/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"苹果查询","enablePullDownRefresh":false})
      },
      [
        createElement('app-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'app-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'app/index/index',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/app/search/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"查询","enablePullDownRefresh":false})
      },
      [
        createElement('app-search-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'app-search-index',
  isNVue:false,maxWidth:0,
  pagePath:'app/search/index',
  windowTop:0
}
},
{
path: '/app/mine/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"我的","enablePullDownRefresh":false})
      },
      [
        createElement('app-mine-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'app-mine-index',
  isNVue:true,maxWidth:0,
  pagePath:'app/mine/index',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:0
}
},
{
path: '/app/user_info/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"我的资料","enablePullDownRefresh":false})
      },
      [
        createElement('app-user_info-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'app-user_info-index',
  isNVue:true,maxWidth:0,
  pagePath:'app/user_info/index',
  windowTop:0
}
},
{
path: '/app/about/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"关于我们","enablePullDownRefresh":false})
      },
      [
        createElement('app-about-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'app-about-index',
  isNVue:true,maxWidth:0,
  pagePath:'app/about/index',
  windowTop:0
}
},
{
path: '/app/product_detail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"商品详情","enablePullDownRefresh":false})
      },
      [
        createElement('app-product_detail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'app-product_detail-index',
  isNVue:false,maxWidth:0,
  pagePath:'app/product_detail/index',
  windowTop:0
}
},
{
path: '/app/help/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"帮助","enablePullDownRefresh":false})
      },
      [
        createElement('app-help-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'app-help-index',
  isNVue:false,maxWidth:0,
  pagePath:'app/help/index',
  windowTop:0
}
},
{
path: '/app/order_submit/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"提交订单","enablePullDownRefresh":false})
      },
      [
        createElement('app-order_submit-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'app-order_submit-index',
  isNVue:false,maxWidth:0,
  pagePath:'app/order_submit/index',
  windowTop:0
}
},
{
path: '/app/query_record/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"查询详情","enablePullDownRefresh":false})
      },
      [
        createElement('app-query_record-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'app-query_record-detail',
  isNVue:false,maxWidth:0,
  pagePath:'app/query_record/detail',
  windowTop:0
}
},
{
path: '/app/notification/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"通知详情","enablePullDownRefresh":false})
      },
      [
        createElement('app-notification-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'app-notification-detail',
  isNVue:false,maxWidth:0,
  pagePath:'app/notification/detail',
  windowTop:0
}
},
{
path: '/app/order_result/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"查询结果","enablePullDownRefresh":false})
      },
      [
        createElement('app-order_result-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'app-order_result-index',
  isNVue:false,maxWidth:0,
  pagePath:'app/order_result/index',
  windowTop:0
}
},
{
path: '/app/orders/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"我的订单","enablePullDownRefresh":false})
      },
      [
        createElement('app-orders-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'app-orders-index',
  isNVue:false,maxWidth:0,
  pagePath:'app/orders/index',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:0
}
},
{
path: '/app/orders/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"订单详情","enablePullDownRefresh":false})
      },
      [
        createElement('app-orders-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'app-orders-detail',
  isNVue:false,maxWidth:0,
  pagePath:'app/orders/detail',
  windowTop:0
}
},
{
path: '/app/wechat-only/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"请在微信中打开","enablePullDownRefresh":false})
      },
      [
        createElement('app-wechat-only-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'app-wechat-only-index',
  isNVue:false,maxWidth:0,
  pagePath:'app/wechat-only/index',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
